import { authenticationInterceptor } from "@interceptors/auth.http-interceptor";
import { withNgxsReduxDevtoolsPlugin } from "@ngxs/devtools-plugin";
import { withNgxsStoragePlugin } from "@ngxs/storage-plugin";
import { provideStore } from "@ngxs/store";
import * as Sentry from "@sentry/angular";
import { CommonState } from "@state/common/common.state";
import { DefaultSettingsState } from "@state/default-settings/default-settings.state";
import { RoutesState } from "@state/routes/routes.state";
import { SessionState } from "@state/session/session.state";
import { UserState } from "@state/user/user.state";

import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from "@angular/common/http";
import {
  type ApplicationConfig,
  ErrorHandler,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from "@angular/core";
import {
  PreloadAllModules,
  provideRouter,
  Router,
  withComponentInputBinding,
  withPreloading,
  withViewTransitions,
} from "@angular/router";

import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: "es-CL" },
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
      withViewTransitions()
    ),
    provideHttpClient(
      withInterceptors([authenticationInterceptor]),
      withFetch()
    ),
    provideStore(
      [CommonState, UserState, SessionState, RoutesState, DefaultSettingsState],
      withNgxsReduxDevtoolsPlugin(),
      withNgxsStoragePlugin({ keys: "*" })
    ),
    provideZonelessChangeDetection(),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
};
